export function BrandMark({ className = "h-12 w-12" }: { className?: string }) {
  return (
    <span
      className={[
        "grid place-items-center rounded-[1.2rem] bg-teal-900/[0.05] text-teal-700 shadow-[inset_0_1px_0_rgba(255,255,255,0.8)]",
        className
      ].join(" ")}
      aria-hidden="true"
    >
      <svg viewBox="0 0 48 48" className="h-6 w-6 fill-current">
        <path d="M24 2.5 29.4 13l11.8 1.7-8.5 8.2 2 11.6L24 29l-10.7 5.5 2-11.6-8.5-8.2L18.6 13 24 2.5Z" />
      </svg>
    </span>
  );
}
